import { Brand } from '@retail/auth/types';
import { Box, Stack, styled, tooltipClasses, TooltipProps } from '@mui/material';
import { BrandLogo, BrandLogoSize, brandLogoSizeMap } from './BrandLogo';
import React from 'react';
import Tooltip from '@mui/material/Tooltip';

interface Props {
  brands: Brand[];
  max?: number;
  size?: BrandLogoSize;
  _internalLastChild?: React.ReactNode;
}

export const BrandLogoGroup: React.FC<Props> = ({
  brands,
  max = 4,
  size = 'medium',
  _internalLastChild,
}) => {
  if (brands.length <= max) {
    return (
      <Stack direction="row" spacing={1}>
        {brands.map((brand) => (
          <Tooltip title={brand.name} key={brand.brandId}>
            <BrandLogo brand={brand} key={brand.brandId} size={size} />
          </Tooltip>
        ))}
        {_internalLastChild}
      </Stack>
    );
  }

  const firstBrands = brands.slice(0, max - 1);
  return (
    <BrandLogoGroup
      brands={firstBrands}
      _internalLastChild={
        <LightTooltip title={<BrandLogoGroup brands={brands} max={brands.length} />}>
          <Box
            component="span"
            borderRadius="50%"
            bgcolor="divider"
            p={0.5}
            height={brandLogoSizeMap[size]}
            width={brandLogoSizeMap[size]}
          >
            {`+${brands.length - max + 1}`}
          </Box>
        </LightTooltip>
      }
    />
  );
};

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`&.${tooltipClasses.popper}`]: {
    backgroundColor: 'transparent',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.vars.palette.background.paper,
    boxShadow: theme.shadows[1],
  },
}));
